import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  data = {
    email: '',
    password: '',
    phone: '',
    name: '',
    display_name: '',
    locationLatitude: '',
    locationLongitude: '',
    type: null,
    plan: null,
  };

  constructor() {}
}
